import { FetchArgs } from '@reduxjs/toolkit/query/react'

export async function applyRestApiSplitTreatments(fetchArgs: FetchArgs): Promise<string> {
  // const splitClientRef = window.getSplitClient ? await window?.getSplitClient() : null
  let adjustedUrl

  //? EXAMPLE: Split treatment for customer-routes-validation
  // const customerRoutesValidationTreatment = splitClientRef?.getTreatment('customer-routes-validation')
  // if (
  //   customerRoutesValidationTreatment === 'on' &&
  //   fetchArgs.url === '/core-api/customers' &&
  //   fetchArgs.method == 'POST'
  // ) {
  //   adjustedUrl = fetchArgs.url.replace('/core-api/customers', '/core-api/customers/v2')
  // }

  return adjustedUrl || fetchArgs.url
}
